// Boş güvenli tarih formatlayıcılar — lang'e göre lokalize
// Gönderim listesi ve kanban görünümleri arasında paylaşılır
export function formatDate(value, lang) {
  if (!value) return '-';
  try {
    const locale = `${lang}-${lang.toUpperCase()}`;
    return new Date(value).toLocaleString(locale);
  } catch {
    return '-';
  }
}

export function formatShortDate(value, lang) {
  if (!value) return '-';
  try {
    const locale = `${lang}-${lang.toUpperCase()}`;
    return new Date(value).toLocaleDateString(locale);
  } catch {
    return '-';
  }
}
